var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio',{key:_vm.option.text,staticClass:"form-color-radio",class:'label-' + _vm.option.value,attrs:{"value":_vm.option.value}})}
var staticRenderFns = []

export { render, staticRenderFns }